// Mock data for the Floenzy luxury brand site.
// NOTE: This is MOCK data used for the frontend-only build. It will be
// replaced with real API data during backend integration.

// Real Floenzy brand photography (user-provided assets).
export const FLOENZY_LOGO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/8q2i4cq1_Floenzy_Logo1.webp";

export const FLOENZY_VIDEO =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/1gta5e7s_Floenzy%20Filtered%20Shower%20Head%20%E2%80%93%203-Stage%20Filtration%20%26%20Vitamin%20C.mp4";

export const FLOENZY_PHOTOS = {
  marble:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/mgybwcdo_sdfsdfsd.jpeg",
  using:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/j7ocr648_FLOENZY%20PHOTO%2016.webp",
  install:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/kb2obog7_FLOENZY%20PHOTO%2001.webp",
  hand:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/ow0mdmb6_61dg53K7jZL._AC_SL1448_%20%282%29.jpg",
  box:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/yt342wge_61ni3DeNvYL._AC_SL1448_%20%281%29.jpg",
  stageCarbon:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/xrn62fsl_22472cce-b408-488d-92f3-ed0d278dfed9.png",
  stageVitaminC:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/xze313nn_7ca8d537-de72-4e43-bbf0-f1e3d5628bc3.png",
  stageMineral:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/zdpbujwd_ChatGPT%20Image%20Sep%2016%2C%202026%2C%2009_38_40%20AM.png",
  waterMap:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_shower-refresh/artifacts/h5lnzup0_04d73c13-1703-4fc0-9ca5-635d9089d136.png",
};

export const IMAGES = {
  bathrooms: [
    "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwYmF0aHJvb218ZW58MHx8fHwxNzg3NzIyNjE5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1576698483491-8c43f0862543?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwYmF0aHJvb218ZW58MHx8fHwxNzg3NzIyNjE5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1643949700215-e61cdca053f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwYmF0aHJvb218ZW58MHx8fHwxNzg3NzIyNjE5fDA&ixlib=rb-4.1.0&q=85",
  ],
  water: [
    "https://images.unsplash.com/photo-1436968188282-5dc61aae3d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxmbG93aW5nJTIwd2F0ZXJ8ZW58MHx8fHwxNzg3NzIyNjE5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/30246727/pexels-photo-30246727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1704428381427-02f6d220a312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxzcGElMjBzaG93ZXJ8ZW58MHx8fHwxNzg3NzIyNjE5fDA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/17210496/pexels-photo-17210496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/flagged/photo-1568196978341-fd5e4d1253ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHx3YXRlciUyMGRyb3BsZXRzfGVufDB8fHx8MTc4NzcyMjYyNnww&ixlib=rb-4.1.0&q=85",
  ],
  beauty: {
    skin: [
      "https://images.unsplash.com/photo-1581182815808-b6eb627a8798?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxnbG93aW5nJTIwc2tpbnxlbnwwfHx8fDE3ODc3MjI2NTh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1581182800629-7d90925ad072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxnbG93aW5nJTIwc2tpbnxlbnwwfHx8fDE3ODc3MjI2NTh8MA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1631743363713-7ffc5d87e248?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxnbG93aW5nJTIwc2tpbnxlbnwwfHx8fDE3ODc3MjI2NTh8MA&ixlib=rb-4.1.0&q=85",
    ],
    hair: [
      "https://images.unsplash.com/photo-1564141696939-9eb6e957ccfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxzaGlueSUyMGhhaXJ8ZW58MHx8fHwxNzg3NzIyNjU5fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1560264641-1b5191cc63e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxzaGlueSUyMGhhaXJ8ZW58MHx8fHwxNzg3NzIyNjU5fDA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/10416604/pexels-photo-10416604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
    droplets: [
      "https://images.pexels.com/photos/8058908/pexels-photo-8058908.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.pexels.com/photos/33217812/pexels-photo-33217812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    ],
  },
  product: [
    "https://m.media-amazon.com/images/I/41+eUCNwpTL._AC_SY879_.jpg",
    "https://m.media-amazon.com/images/I/61RIQ5VzabL._SY500_.jpg",
    "https://m.media-amazon.com/images/I/61f6rlTZV6L._SY500_.jpg",
    "https://m.media-amazon.com/images/I/61iTAd7CCjL._SY500_.jpg",
    "https://m.media-amazon.com/images/I/71y+D2zJxAL._SY500_.jpg",
    "https://m.media-amazon.com/images/I/61dl0gual1L._SY500_.jpg",
  ],
};

export const AMAZON_URL =
  "https://www.amazon.co.uk/s?k=FLOENZY";

export const PRODUCT = {
  name: "Floenzy",
  title: "The Premium Filtered Shower Head",
  tagline: "3-Stage Vitamin C Filtration for Softer Skin & Less Hair Fall",
  price: 55.0,
  currency: "£",
  rating: 4.3,
  reviewCount: 12,
  images: [
    FLOENZY_PHOTOS.hand,
    FLOENZY_PHOTOS.box,
    FLOENZY_PHOTOS.marble,
    "https://m.media-amazon.com/images/I/41+eUCNwpTL._AC_SY879_.jpg",
    FLOENZY_PHOTOS.install,
    "https://m.media-amazon.com/images/I/61RIQ5VzabL._SY500_.jpg",
  ],
  assurances: [
    "Complimentary UK delivery",
    "30-day returns",
    "2-year guarantee",
  ],
  colours: [
    { name: "Beige", hex: "#D8CBB6" },
    { name: "Grey-red", hex: "#8C7A76" },
  ],
  highlights: [
    "Reduces chlorine, limescale & heavy metals at the source",
    "Vitamin C neutralises up to 98% of chlorine on contact",
    "392 precision micro-holes — spa pressure, no dribble",
    "Fits standard UK ½″ hoses. Tool-free in under 2 minutes",
  ],
  description:
    "Transform your daily shower into a spa-like ritual. Floenzy's advanced 3-stage filtration — activated carbon fibre, vitamin C, and multi-layer media — reduces chlorine, impurities and the effects of hard water for cleaner, softer, fresher water. With 392 micro-nozzle outlets, the spray feels both invigorating and gentle. Softer skin, healthier-looking hair, and a shower that finally feels like it should.",
};

export const NAV = [
  { label: "The Water", to: "/the-water" },
  { label: "Filtration", to: "/filtration" },
  { label: "Our Story", to: "/our-story" },
  { label: "Gallery", to: "/gallery" },
  { label: "Shop", to: "/shop" },
];

export const STAGES = [
  {
    no: "01",
    kicker: "stage one",
    title: "Activated Carbon Fibre",
    body: "A dense bed of activated carbon fibre captures chlorine, sediment and dissolved heavy metals — the invisible residue that leaves skin tight and hair brittle.",
    image: FLOENZY_PHOTOS.stageCarbon,
  },
  {
    no: "02",
    kicker: "stage two",
    title: "Vitamin C Infusion",
    body: "The same method used in professional spas. Vitamin C neutralises up to 98% of chlorine on contact, leaving water noticeably softer from the very first shower.",
    image: FLOENZY_PHOTOS.stageVitaminC,
  },
  {
    no: "03",
    kicker: "stage three",
    title: "Multi-Layer Mineral Balance",
    body: "A final multi-layer media polishes the water and calms hard-water minerals — so your conditioner, your moisturiser, and your skin all simply work better.",
    image: FLOENZY_PHOTOS.stageMineral,
  },
];

export const BENEFITS = [
  {
    kicker: "for your skin",
    title: "Softer, calmer, less tight.",
    body: "Hard water strips moisture and clogs pores. Remove what's damaging your skin at the source and everything after — your moisturiser, your routine — works better.",
    image:
      "https://images.unsplash.com/photo-1581182815808-b6eb627a8798?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxnbG93aW5nJTIwc2tpbnxlbnwwfHx8fDE3ODc3MjI2NTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    kicker: "for your hair",
    title: "Shinier, softer, less frizz.",
    body: "Chlorine and minerals cause breakage and dullness. Filtered water leaves hair smoother and easier to manage — noticeable from your first wash.",
    image:
      "https://images.unsplash.com/photo-1564141696939-9eb6e957ccfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxzaGlueSUyMGhhaXJ8ZW58MHx8fHwxNzg3NzIyNjU5fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Will it reduce my water pressure?",
    a: "No — Floenzy is engineered to maintain and even boost pressure while filtering. 392 precision micro-holes increase water velocity for a stronger, more focused flow than a standard shower head.",
  },
  {
    q: "How often do I replace the filter cartridge?",
    a: "Each Floenzy cartridge is designed to last approximately 2–3 months based on typical daily use.",
  },
  {
    q: "Will it fit my shower?",
    a: "Yes — Floenzy uses a universal ½″ BSP connection, the standard fitting for virtually all UK shower hoses and shower arms. It installs tool-free in minutes.",
  },
  {
    q: "Will it work with my electric shower or combi boiler?",
    a: "Floenzy is compatible with both combi boiler systems (gravity and pressurised) and electric shower systems.",
  },
];

export const REVIEWS = [
  {
    name: "Christiany",
    location: "United Kingdom",
    rating: 5,
    title: "A noticeable difference in the shower",
    body: "Straightforward to fit onto my existing UK shower hose — no tools needed. The water pressure is good and the water feels nicer on my skin. The three-stage filtration and vitamin C are a lovely addition, and it doesn't look out of place in the bathroom.",
  },
  {
    name: "Recommended Reviews",
    location: "United Kingdom",
    rating: 5,
    title: "The flo that steals the show",
    body: "Fitting it was quick and simple — unscrew the old, screw on the new. The pressure is excellent and consistent, and the modern design looks great in the bathroom. Highly recommended.",
  },
  {
    name: "Fab Finds",
    location: "United Kingdom",
    rating: 4,
    title: "Noticeable difference in skin and hair",
    body: "After a couple of weeks, skin feels far less dry and hair feels softer without that stiff residue left by chlorine and minerals. The pressure stays strong and steady through the multi-stage filter.",
  },
];

export const STATS = [
  { value: "60%", label: "of UK homes have hard water" },
  { value: "98%", label: "of chlorine neutralised on contact" },
  { value: "392", label: "precision micro-holes" },
  { value: "2 min", label: "tool-free installation" },
];
